/*
  MSM mega nav v2 (Oct 15)
  - Desktop dropdowns: click or hover (mouse) to open; aria-expanded kept in sync; Down arrow opens and
    focuses the first link, Left/Right move between top-level items, Esc closes and returns focus.
  - Columns marked data-msm-same-as are filled from the first dropdown's matching column (identical content
    is only sent once in the HTML).
  - Mobile drawer: built from the desktop menu markup on first open; focus is trapped while open, Esc closes.
*/
(function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var current = null;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }
  function caret() {
    var s = document.createElementNS(SVG_NS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    var u = document.createElementNS(SVG_NS, 'use');
    u.setAttribute('href', '#msmi-caret');
    s.appendChild(u);
    return s;
  }
  function copyLink(a, cls) {
    var n = el('a', cls);
    n.href = a.getAttribute('href');
    n.innerHTML = a.innerHTML;
    return n;
  }

  function initMegaNav(section) {
    var nav = section.querySelector('.msm-nav');
    if (!nav || nav.dataset.msmReady) return null;
    nav.dataset.msmReady = '1';
    var hoverOpen = nav.getAttribute('data-hover-open') === 'true';
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    var toggles = Array.prototype.slice.call(nav.querySelectorAll('.msm-nav-list [aria-controls]'));
    var topLinks = Array.prototype.slice.call(nav.querySelectorAll('.msm-nav-list > .msm-nav-item > .msm-nav-link'));

    function panelFor(btn) {
      return document.getElementById(btn.getAttribute('aria-controls'));
    }

    /* fill shared columns (sent once) into the dropdowns that reuse them */
    function fillShared(panel) {
      if (!panel) return;
      panel.querySelectorAll('[data-msm-same-as]').forEach(function (slot) {
        if (slot.childElementCount) return;
        var src = document.getElementById(slot.getAttribute('data-msm-same-as'));
        if (src) slot.innerHTML = src.innerHTML;
      });
    }

    function closeAll(except) {
      toggles.forEach(function (btn) {
        if (btn === except) return;
        var panel = panelFor(btn);
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-active');
        if (panel) panel.classList.remove('is-open');
        var li = btn.closest('.msm-nav-item');
        if (li) li.classList.remove('is-open');
      });
    }

    function open(btn, focusFirst) {
      var panel = panelFor(btn);
      if (!panel) return;
      fillShared(panel);
      closeAll(btn);
      btn.setAttribute('aria-expanded', 'true');
      if (btn.hasAttribute('data-msm-toggle-main')) {
        panel.classList.add('is-open');
        btn.classList.add('is-active');
      } else {
        btn.closest('.msm-nav-item').classList.add('is-open');
      }
      if (focusFirst) {
        var first = panel.querySelector('a[href], button, input');
        if (first) first.focus();
      }
    }

    function isOpen(btn) {
      return btn.getAttribute('aria-expanded') === 'true';
    }

    toggles.forEach(function (btn) {
      var panel = panelFor(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        /* a click right after hover opened the menu keeps it open instead of toggling it shut */
        if (isOpen(btn) && Date.now() - (btn._hoverOpenedAt || 0) < 500) return;
        if (isOpen(btn)) closeAll();
        else open(btn, false);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open(btn, true);
        } else if (e.key === 'Escape') {
          closeAll();
        }
      });
      if (!panel) return;
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.stopPropagation();
          closeAll();
          btn.focus();
        }
      });

      /* hover intent on desktop mice: open after a short pause, close after leaving both button and panel */
      if (hoverOpen && canHover) {
        var openTimer;
        var closeTimer;
        var li = btn.closest('.msm-nav-item');
        var enter = function () {
          clearTimeout(closeTimer);
          if (isOpen(btn)) return;
          openTimer = setTimeout(function () {
            open(btn, false);
            btn._hoverOpenedAt = Date.now();
          }, 140);
        };
        var leave = function () {
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () {
            if (!li.matches(':hover') && !panel.matches(':hover') && !panel.contains(document.activeElement)) {
              btn.setAttribute('aria-expanded', 'false');
              btn.classList.remove('is-active');
              panel.classList.remove('is-open');
              li.classList.remove('is-open');
            }
          }, 260);
        };
        li.addEventListener('mouseenter', enter);
        li.addEventListener('mouseleave', leave);
        panel.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });
        panel.addEventListener('mouseleave', leave);
      }
    });

    /* Left/Right arrows move between top-level items */
    topLinks.forEach(function (link, i) {
      link.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = topLinks[(i + (e.key === 'ArrowRight' ? 1 : -1) + topLinks.length) % topLinks.length];
        var wasOpen = toggles.some(isOpen);
        next.focus();
        if (wasOpen && next.hasAttribute('aria-controls')) open(next, false);
        else if (wasOpen) closeAll();
      });
    });

    nav.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !nav.contains(e.relatedTarget)) closeAll();
    });

    /* ---------- mobile drawer ---------- */
    var drawer = section.querySelector('[data-msm-drawer]');
    var overlay = section.querySelector('[data-msm-drawer-overlay]');
    var body = drawer && drawer.querySelector('[data-msm-drawer-body]');
    var social = body && body.querySelector('.msm-drawer-social');
    var built = false;
    var lastFocus = null;

    function heading(col) {
      var t = col.querySelector('.msm-col-title');
      return t ? el('p', 'msm-drawer-sub-heading', t.textContent.trim()) : null;
    }
    function viewAll(col, sub) {
      var v = col.querySelector(':scope > .msm-view-all');
      if (v) sub.appendChild(copyLink(v, 'msm-drawer-view-all'));
    }

    function fillFromPanel(panel, sub) {
      fillShared(panel);
      if (panel.classList.contains('msm-simple-panel')) {
        var g = el('div', 'msm-drawer-grid-2 msm-drawer-submenu-grid');
        panel.querySelectorAll('a').forEach(function (a) {
          g.appendChild(copyLink(a, 'msm-drawer-grid-link msm-drawer-grid-link--plain'));
        });
        sub.appendChild(g);
        return;
      }
      panel.querySelectorAll('.msm-mega-inner > .msm-col').forEach(function (col) {
        var type = col.getAttribute('data-col');
        var h = heading(col);
        if (type === 'cats' || type === 'guides') {
          if (type === 'guides' && h) sub.appendChild(h);
          var grid = el('div', 'msm-drawer-grid-2');
          col.querySelectorAll('.msm-link-list a').forEach(function (a) {
            grid.appendChild(copyLink(a, 'msm-drawer-grid-link'));
          });
          sub.appendChild(grid);
          viewAll(col, sub);
        } else if (type === 'brands') {
          if (h) sub.appendChild(h);
          var bg = el('div', 'msm-drawer-grid-3');
          col.querySelectorAll('.msm-brand-list > a').forEach(function (a) {
            var n = copyLink(a, 'msm-drawer-brand');
            var name = n.querySelector('.msm-brand-name');
            if (name) name.className = '';
            bg.appendChild(n);
          });
          sub.appendChild(bg);
          viewAll(col, sub);
        } else if (type === 'exp') {
          if (h) sub.appendChild(h);
          var list = el('div', 'msm-drawer-exp-list');
          col.querySelectorAll('.msm-exp-card').forEach(function (a) {
            var card = el('a', 'msm-drawer-exp-card');
            card.href = a.getAttribute('href');
            var text = el('span', 'msm-drawer-exp-text');
            var lbl = a.querySelector('.msm-exp-label');
            var subt = a.querySelector('.msm-exp-sub');
            text.appendChild(el('span', 'msm-drawer-exp-label', lbl ? lbl.textContent.trim() : ''));
            text.appendChild(el('span', 'msm-drawer-exp-sub', subt ? subt.textContent.trim() : ''));
            card.appendChild(text);
            var img = a.querySelector('img');
            if (img) card.appendChild(img.cloneNode(true));
            list.appendChild(card);
          });
          sub.appendChild(list);
          viewAll(col, sub);
        } else if (type === 'services') {
          if (h) sub.appendChild(h);
          var hero = col.querySelector('.msm-service-hero');
          if (hero) {
            var hn = el('a', 'msm-drawer-service-hero');
            hn.href = hero.getAttribute('href');
            var himg = hero.querySelector('img');
            if (himg) hn.appendChild(himg.cloneNode(true));
            var hs = el('span');
            var hst = hero.querySelector('strong');
            var hp = hero.querySelector('p');
            var hl = hero.querySelector('.msm-service-hero-link');
            if (hst) hs.appendChild(el('strong', '', hst.textContent.trim()));
            if (hp) hs.appendChild(el('p', '', hp.textContent.trim()));
            if (hl) hs.appendChild(el('span', 'msm-drawer-service-link', hl.textContent.trim()));
            hn.appendChild(hs);
            sub.appendChild(hn);
          }
          col.querySelectorAll('.msm-service-block').forEach(function (b) {
            var bn = el('div', 'msm-drawer-service-block');
            var svg = b.querySelector('svg');
            if (svg) bn.appendChild(svg.cloneNode(true));
            var span = el('span');
            var st = b.querySelector('strong');
            var sp = b.querySelector('p');
            if (st) span.appendChild(el('strong', '', st.textContent.trim()));
            if (sp) span.appendChild(el('p', '', sp.textContent.trim()));
            var link = b.querySelector('a');
            if (link) span.appendChild(copyLink(link, link.classList.contains('msm-service-phone') ? 'msm-drawer-service-phone' : ''));
            bn.appendChild(span);
            sub.appendChild(bn);
          });
        }
      });
      var extras = panel.querySelector('[data-msm-extras]');
      if (extras) {
        var ex = extras.cloneNode(true);
        ex.querySelectorAll('[id]').forEach(function (n) {
          var lbl = ex.querySelector('label[for="' + n.id + '"]');
          n.id = n.id + '-m';
          if (lbl) lbl.setAttribute('for', n.id);
        });
        ex.classList.add('msm-mega-extras--drawer');
        sub.appendChild(ex);
      }
    }

    function buildDrawer() {
      if (built || !body) return;
      built = true;
      topLinks.forEach(function (link, idx) {
        var label = (link.querySelector('.msm-nav-link-text') || link).textContent.trim();
        var item = el('div', 'msm-drawer-item');
        var panel = link.hasAttribute('aria-controls') ? panelFor(link) : null;
        if (!panel) {
          var a = el('a', 'msm-drawer-row', label);
          a.href = link.getAttribute('href') || '#';
          item.appendChild(a);
          body.insertBefore(item, social);
          return;
        }
        var sub = el('div', 'msm-drawer-sub');
        sub.id = 'msm-dsub-' + idx;
        var toggle;
        if (idx === 0 && link.closest('.msm-nav-item--shop')) {
          var wrap = el('div', 'msm-drawer-row msm-drawer-row-main-wrap');
          toggle = el('button', 'msm-drawer-row-main');
          var lab = el('span', 'msm-drawer-row-main-label', label);
          lab.appendChild(caret());
          toggle.appendChild(lab);
          var close = el('button', 'msm-drawer-close');
          close.type = 'button';
          close.setAttribute('aria-label', 'Close menu');
          close.setAttribute('data-msm-drawer-close', '');
          close.innerHTML =
            '<svg class="msm-no-rotate" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke-width="1.8" stroke-linecap="round"/></svg>';
          wrap.appendChild(toggle);
          wrap.appendChild(close);
          item.appendChild(wrap);
        } else {
          toggle = el('button', 'msm-drawer-row', label);
          toggle.appendChild(caret());
          item.appendChild(toggle);
        }
        toggle.type = 'button';
        toggle.setAttribute('data-msm-drawer-toggle', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', sub.id);
        fillFromPanel(panel, sub);
        item.appendChild(sub);
        body.insertBefore(item, social);
      });
    }

    function hamburgers() {
      return document.querySelectorAll('[data-msm-mobile-toggle]');
    }
    function focusables() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll('a[href], button, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
        function (n) {
          return n.offsetParent !== null;
        }
      );
    }

    function openDrawer() {
      if (!drawer) return;
      buildDrawer();
      lastFocus = document.activeElement;

      /* Position the drawer below the announcement bar + header so they stay visible */
      var headerBottom = 0;
      var groupParent = section.parentElement;
      if (groupParent) {
        var siblings = groupParent.querySelectorAll('.shopify-section');
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] === section || siblings[i].contains(section)) break;
          headerBottom += siblings[i].getBoundingClientRect().height;
        }
      }
      drawer.style.top = headerBottom + 'px';
      overlay.style.top = headerBottom + 'px';

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      hamburgers().forEach(function (h) {
        h.setAttribute('aria-expanded', 'true');
      });
      setTimeout(function () {
        var first = focusables()[0];
        if (first) first.focus();
      }, 50);
    }

    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
      drawer.querySelectorAll('.msm-drawer-item.is-open').forEach(function (n) {
        n.classList.remove('is-open');
        var t = n.querySelector('[data-msm-drawer-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      hamburgers().forEach(function (h) {
        h.setAttribute('aria-expanded', 'false');
      });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    hamburgers().forEach(function (h) {
      h.setAttribute('aria-controls', 'msm-drawer');
      h.setAttribute('aria-expanded', 'false');
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-msm-drawer-close]')) {
          closeDrawer();
          return;
        }
        var t = e.target.closest('[data-msm-drawer-toggle]');
        if (t) {
          var item = t.closest('.msm-drawer-item');
          var opened = item.classList.toggle('is-open');
          t.setAttribute('aria-expanded', opened ? 'true' : 'false');
        }
      });
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDrawer();
        } else if (e.key === 'Tab') {
          var f = focusables();
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) {
            e.preventDefault();
            f[f.length - 1].focus();
          } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
            e.preventDefault();
            f[0].focus();
          }
        }
      });
    }

    return {
      section: section,
      nav: nav,
      openDrawer: openDrawer,
      closeAll: closeAll,
      anyOpen: function () {
        return toggles.some(isOpen);
      },
    };
  }

  function boot(root) {
    var s = (root || document).querySelector('.section-msm-mega-nav') || (root && root.classList && root.classList.contains('section-msm-mega-nav') ? root : null);
    if (!s) return;
    var api = initMegaNav(s);
    if (api) current = api;
  }

  /* document-level listeners are registered once and act on the current menu */
  document.addEventListener('msm:open-mobile-menu', function () {
    if (current) current.openDrawer();
  });
  document.addEventListener('click', function (e) {
    if (current && !current.section.contains(e.target)) current.closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current && current.anyOpen() && !current.nav.contains(document.activeElement)) current.closeAll();
  });
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }
})();
